'use client'
import { createContext } from 'react'

export type AccordionContextType = {
  currentIndex?: number
  setCurrentIndex: (index?: number) => void
}

const dummy = (_index?: number) => null
export const AccordionContext = createContext<AccordionContextType>({ currentIndex: undefined, setCurrentIndex: dummy })
